var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn"}},[_vm._v("粤ICP备15059815号")])])
}]

export { render, staticRenderFns }